import { ComponentType } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- MDC Dialog Service
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

// Mode defaults for dialogs
const MODE_DIALOG_DEFAULTS: MatDialogConfig = {
  panelClass: 'mode-dialog',
  autoFocus: false,
  width: '472px',
};

interface CustomConfig {
  /** If true, the dialog will render in the center of the viewport. If false, the dialog will render near the top of the viewport. */
  centered: boolean;
}

/**
 * MDC-based Dialog Service.
 * This is the modern replacement for DialogService that uses MDC MatDialog.
 * Provided in root to be a singleton and avoid dependency on SharedUiModule.
 */
@Injectable({ providedIn: 'root' })
export class MdcDialogService {
  constructor(private dialog: MatDialog) {}

  getDialogById(id: string) {
    return this.dialog.getDialogById(id);
  }

  getOptions<T>({
    matDialogConfig = {},
    customConfig = { centered: false },
  }: {
    matDialogConfig?: MatDialogConfig<T>;
    customConfig?: CustomConfig;
  }): MatDialogConfig<T> {
    return { ...MODE_DIALOG_DEFAULTS, ...matDialogConfig, position: customConfig.centered ? {} : { top: '56px' } };
  }

  open<T, D = unknown, R = unknown>({
    component,
    matDialogConfig,
    customConfig,
  }: {
    /** The component to dynamically render inside the dialog. */
    component: ComponentType<T>;
    /** The Angular Material library's configuration options for the dialog. */
    matDialogConfig?: MatDialogConfig<D>;
    /** Mode's own configuration options for the dialog. */
    customConfig?: CustomConfig;
  }): MatDialogRef<T, R> {
    return this.dialog.open(component, this.getOptions<D>({ matDialogConfig, customConfig }));
  }

  closeAll() {
    this.dialog.closeAll();
  }
}
